import styled, { css } from "styled-components";

import { colors } from "~/styles";

const { risks } = colors;

export const Container = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 8px;
  background-color: ${({ impactId }) => {
    switch (impactId) {
      case 1:
        return risks.low;
      case 2:
        return risks.medium;
      case 3:
        return risks.high;
      case 4:
        return risks.critical;
      default:
        return "#ccc"; // cor padrão caso não tenha impactId
    }
  }};
`;
